import { render, staticRenderFns } from "./SmartMorphIcon.vue?vue&type=template&id=e0b1376c&"
import script from "./SmartMorphIcon.vue?vue&type=script&lang=js&"
export * from "./SmartMorphIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports